var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 84,
    viewBox: "0 0 96 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5029 67.2246H87.4395V59.2993V58.7587L86.9005 58.8008C86.8315 58.8062 86.7714 58.8195 86.7268 58.8312C86.7059 58.8367 86.6848 58.8429 86.6661 58.8485C86.6472 58.8542 86.6308 58.8594 86.6198 58.8628C86.5973 58.8698 86.584 58.8733 86.5776 58.875H12.4494C10.3057 58.875 8.58203 57.0793 8.58203 54.9055V14.7601C8.58203 12.601 10.2911 10.8906 12.4494 10.8906H52.8413C54.7673 10.8906 56.5059 9.72864 57.3028 7.99165L57.3034 7.99038L59.661 2.81433C60.3011 1.41923 61.6929 0.5 63.2136 0.5H86.5938C88.7449 0.5 90.5215 2.31346 90.5215 4.47966V47.8711V67.6721C90.5215 68.5057 89.8351 69.1981 89.0122 69.1981C88.1707 69.1981 87.5029 68.5486 87.5029 67.7246V67.2246Z",
    fill: "#800202",
    stroke: "#B80211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4395 67.7246V68.2246H86.5528C86.7866 69.3739 87.8128 70.1981 89.0122 70.1981C89.4929 70.1981 89.9408 70.0597 90.3213 69.822C89.6961 72.5973 87.2334 74.6645 84.2698 74.6645C83.9844 74.6645 83.6987 74.638 83.4084 74.5978L83.3314 74.5871L83.2547 74.6003C83.0503 74.6357 82.8309 74.6465 82.5863 74.6465H8.44199C6.27487 74.6465 4.5 72.9122 4.5 70.762V26.3812C4.5 24.216 6.28984 22.3945 8.44199 22.3945H82.5863C84.7255 22.3945 86.4395 24.2026 86.4395 26.3812V67.7246Z",
    fill: "#FFE9E9",
    stroke: "#B80211"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5234",
    x: 0,
    y: 0,
    width: 95.0215,
    height: 83.1645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5234",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/DocumentIcon.084eb55a23442099e74fcfa0b2bc731c.svg";
export { ForwardRef as ReactComponent };